import { Set } from "immutable";
import { createSelector } from "reselect";

import { REFERENCE_RELATES_TO } from "../../../constants/references";
import definitionSelectors from "../selectors";

const getReferenceAllIds = state => {
  return definitionSelectors.getEnabledDefinitions(state).references.allIds;
};

const getReferencesById = state => definitionSelectors.getReferencesById(state);

const getOrderedReferences = createSelector(
  // Input functions
  getReferenceAllIds,
  getReferencesById,
  // Final function
  (allReferenceIds, referencesById) => {
    return allReferenceIds.map(id => referencesById.get(id));
  }
);

const getOrderedReferencesForTypeIds = (state, typeIdSet) => {
  const definitions = definitionSelectors.getEnabledDefinitions(state);
  const referenceIds = Set().withMutations(refIds => {
    definitions.types.byId
      .filter(t => typeIdSet.has(t.id))
      .forEach(t => {
        refIds.union(t.references.toSet());
      });
  });
  return definitions.references.allIds
    .map(id => {
      return referenceIds.has(id) ? getReferencesById(state).get(id) : null;
    })
    .filter(p => p);
};

// const getOrderedReferences = state =>
//   getReferenceAllIds(state).map(id => definitionSelectors.getReferencesById(state).get(id));

const getReferencesWithTypeFromReferences = (references, type) => references.filter(r => r.types.includes(type));

const getReferencesWithType = (state, type) => getReferencesWithTypeFromReferences(getOrderedReferences(state), type);

const doesRelatesToExist = state => getReferencesById(state).has(REFERENCE_RELATES_TO);

export default {
  getReferenceAllIds,
  getOrderedReferences,
  getOrderedReferencesForTypeIds,
  getReferencesById,
  getReferencesWithTypeFromReferences,
  getReferencesWithType,
  doesRelatesToExist
};
